import { INativeAdsConfiguration } from "@almamedia/amr-adtech-stack/lib/services/native/native-ads";
import { addTemplate } from "@almamedia/amr-adtech-stack/lib/services/native/native-helpers";
import { nativeFbAd } from "@almamedia/amr-adtech-stack/lib/services/native/templates/native-fb-ad";
import nativeSquareBlue from "@almamedia/amr-adtech-stack/lib/services/native/templates/native-square-blue";
import nativeRectangleBlackWide from "@almamedia/amr-adtech-stack/lib/services/native/templates/native-rectangle-black-wide";

type SiteNativeTemplate =
  | "native_fb_ad"
  | "native_square_blue"
  | "native_rectangle_black_wide";

const nativeAds: INativeAdsConfiguration<SiteNativeTemplate> = {
  defaults: {
    nativeFields: {
      title: {
        required: true,
        max_length: 120,
      },
      body: {
        required: false,
        max_length: 150,
      },
      image: {
        required: true,
        sizes: [
          {
            width: 1200,
            height: 628,
          },
          {
            width: 1200,
            height: 630,
          },
          {
            width: 1200,
            height: 675,
          },
          {
            width: 600,
            height: 314,
          },
          {
            width: 600,
            height: 315,
          },
          {
            width: 600,
            height: 338,
          },
        ],
      },
      video: {
        required: false,
      },
      icon: {
        required: false,
        sizes: [],
      },
      sponsoredBy: {
        required: true,
        max_length: 50,
      },
      clickUrl: {
        required: true,
      },
      cta: {
        required: false,
      },
      displayUrl: {
        required: false,
      },
      desc2: {
        required: false,
      },
      privacySupported: true,
    },
  },
  templates: [
    addTemplate<SiteNativeTemplate>(nativeFbAd),
    addTemplate<SiteNativeTemplate>(nativeSquareBlue),
    addTemplate<SiteNativeTemplate>(nativeRectangleBlackWide),
  ],
};

export default nativeAds;
export type { SiteNativeTemplate };
